<template>
  <v-container
    id="cobraTab"
    class="pa-0"
  >
    <base-resource-grid
      color="green"
      icon="mdi-clipboard-flow"
      plural-name="COBRA"
      singular-name="COBRA"
      allow-expand
      :headers="gridHeaders"
      :resource="cobraResource"
      :fetch-method="getCobra"
      :actions="actions"
      :prepare-save="prepareSave"
      :disabled="disabled"
      @handleAction="handleAction"
      @item:updated="itemChanged"
      @item:added="itemChanged"
      @item:deleted="itemChanged"
    >
      <template
        v-slot:editForm="bindings"
        class="pa-0"
      >
        <cobra-edit
          v-model="bindings.editedItem"
          class="pa-0"
          :open-enrollment="openEnrollment"
          :form-errors="bindings.formErrors"
          :disabled="disabled"
        />
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="oeCobraHistory/"
      id-field="oeCobraId"
      title-field="Cobra"
      color="green"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'CobraTab',

    components: {
      CobraEdit: () => import('./CobraEdit'),
    },

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      gridHeaders: [
        {
          text: 'Product',
          value: 'product',
        },
        {
          text: 'Carrier',
          value: 'carrier',
        },
      ],

      historyColumns: [
        {
          text: 'Product',
          value: 'product',
        },
        {
          text: 'Carrier',
          value: 'carrier',
        },
        {
          text: 'Administering Carrier',
          value: 'carrierAdministering',
        },
        {
          text: 'COBRA Eligible',
          value: 'cobraEligible',
          dataType: 'boolean',
        },
        {
          text: 'Send Files To Product Carrier (EDI)',
          value: 'sendFilesToProductCarrierEDI',
          dataType: 'boolean',
        },
        {
          text: 'Send Initial Notices and Terms to Cobra Admin',
          value: 'sendInitialNoticesTermsToCobraAdmin',
          dataType: 'boolean',
        },
        {
          text: 'Rates different than active',
          value: 'ratesDiffThanActive',
          dataType: 'boolean',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      cobraResource: new TroodyApi('oeCobra/'),

      historyItem: null,
    }),

    methods: {
      getCobra () {
        return this.cobraResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
      },

      prepareSave (payload) {
        if (payload) {
          payload.openEnrollmentId = this.openEnrollment.id
        }
        return payload
      },
    },
  }
</script>
